import { AmberHoc, AmberHocProps } from '../../../util';
import {
  SaveTemporaryInputConditionsMutation as Result,
  SaveTemporaryInputConditionsMutationVariables as Variables,
  withSaveTemporaryInputConditions as HOC,
} from '../__generated';
import { GraphQLErrors } from './error';

export type WithSaveTemporaryInputConditionsHocChildProps = {
  saveTemporaryInputConditions: (
    variables: Variables
  ) => Promise<Result['saveTemporaryInputConditions']>;
};

export const withSaveTemporaryInputConditionsHoc: AmberHoc<
  {},
  WithSaveTemporaryInputConditionsHocChildProps
> = (component) =>
  HOC<
    AmberHocProps<{}, WithSaveTemporaryInputConditionsHocChildProps, typeof component>,
    WithSaveTemporaryInputConditionsHocChildProps
  >({
    options: { errorPolicy: 'all' },
    props: (props) => {
      const { mutate } = props;
      return {
        saveTemporaryInputConditions: async (variables) => {
          if (!mutate) {
            throw new Error('Unexpected UI error');
          }

          const result = await mutate({ variables });

          if (!result) {
            throw new Error('Unexpected server response');
          }

          const { errors, data } = result;
          if (errors) {
            throw new GraphQLErrors(errors);
          }
          if (!data) {
            throw new Error('Unexpected server response');
          }
          return data.saveTemporaryInputConditions;
        },
      };
    },
  })(component as any);
